import {
  Alert,
  Box,
  Button,
  Card,
  Checkbox,
  darken,
  FormControlLabel,
  FormGroup,
  IconButton,
  Input,
  InputAdornment,
  lighten,
  MenuItem,
  Modal,
  Slider,
  Snackbar,
  Stack,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Drawer,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { v4 as uuidv4 } from "uuid";
import useStyles from "./styles";
import { useEffect, useMemo, useState } from "react";
import api from "../../../services/api";

import {
  Check,
  CloseOutlined,
  Delete,
  Add,
  MapOutlined,
  RouteOutlined,
} from "@mui/icons-material";
import Escala from "./escala";
import AlertModal from "../../alertModal";
import Alerts from "../alerts";
import CustomTreeView from "../../sideBar/customTreeView";
import FiltroEscala from "./filtroEscala";
import { use } from "react";

export default function ConfiguracaoEasyMapsModal({
  open,
  setOpen = () => {},
  config,
  setConfig = () => {},
  setConfigLocal = () => {},
  tabDefault = 0,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const unidadeTempoFtthIninicial = 60000;
  const isDownMd = useMediaQuery(theme.breakpoints.down("md"));

  const [snackbar, setSnackbar] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [pageIndex, setPageIndex] = useState("1.1.1");
  const [openAlertModal, setOpenAlertModal] = useState(null);
  const [checkChanges, setCheckChanges] = useState(false);
  const [linkFTTHVerification, setLinkFTTHVerification] = useState({});
  // página geral
  const [mapCustom, setMapCustom] = useState(false);

  //pagina de geolocalizado
  const [linkLight, setLinkLight] = useState(null);
  const [linkDark, setLinkDark] = useState(null);
  const [limiar, setLimiar] = useState(null);
  const [tempoColetaGeo, setTempoColetaGeo] = useState(60000);
  const [valorTempoGeo, setValorTempoGeo] = useState(1);
  const [unidadeTempoGeo, setUnidadeTempoGeo] = useState(
    unidadeTempoFtthIninicial,
  );
  const [escalaTrafegoGeo, setEscalaTrafegoGeo] = useState([]);
  const [escalaPotenciaGeo, setEscalaPotenciaGeo] = useState([]);
  const [animacaoLinhaGeo, setAnimacaoLinhaGeo] = useState(true);
  const [animacaoAlertasGeo, setAnimacaoAlertasGeo] = useState(true);
  const [sizeIconsGeo, setSizeIconsGeo] = useState(3);
  const [larguraEnlaceGeo, setLarguraEnlaceGeo] = useState(7);
  const [larguraEnlaceTop, setLarguraEnlaceTop] = useState(7);
  const [filtroPotenciaGeo, setFiltroPotenciaGeo] = useState(null);
  const [filtroTrafegoGeo, setFiltroTrafegoGeo] = useState(null);

  // pagina de topologia
  const [tempoColetaTop, setTempoColetaTop] = useState(60000);
  const [valorTempoTop, setValorTempoTop] = useState(1);
  const [unidadeTempoTop, setUnidadeTempoTop] = useState(
    unidadeTempoFtthIninicial,
  );
  const [escalaTrafegoTop, setEscalaTrafegoTop] = useState([]);
  const [escalaPotenciaTop, setEscalaPotenciaTop] = useState([]);
  const [animacaoLinhaTop, setAnimacaoLinhaTop] = useState(true);
  const [animacaoAlertasTop, setAnimacaoAlertasTop] = useState(true);
  const [sizeIconsTop, setSizeIconsTop] = useState(3);
  const [filtroPotenciaTop, setFiltroPotenciaTop] = useState(null);
  const [filtroTrafegoTop, setFiltroTrafegoTop] = useState(null);

  //pagina de ftth
  const [escalaFtth, setEscalaFtth] = useState([]);
  const [tempoColetaFtth, setTempoColetaFtth] = useState(5 * 60000);
  const [valorTempoFtth, setValorTempoFtth] = useState(5);
  const [unidadeTempoFtth, setUnidadeTempoFtth] = useState(
    unidadeTempoFtthIninicial,
  );
  const [linkFtth, setLinkFtth] = useState([]);
  const [clusterFtth, setClusterFtth] = useState(0);
  const [clusterArea, setClusterArea] = useState(2.5);
  const [clusterIconSize, setClusterIconSize] = useState(3);
  const [onuIcon, setOnuIcon] = useState(3);
  const [noDataElements, setNoDataElements] = useState(true);
  const [filtroPotencia, setFiltroPotencia] = useState(null);
  const [animacaoLinhaFtth, setAnimacaoLinhaFtth] = useState(true);
  const [animacaoAlertasFtth, setAnimacaoAlertasFtth] = useState(true);
  const [defaultSelectedItems, setDefaultSelectedItems] = useState([]);

  const [openDrawer, setOpenDrawer] = useState(false);
  const ftthPing_flag = useMemo(() => {
    return config?.configuracoes.ftthPing_flag;
  }, [config]);

  const marks = [
    { value: 0, label: "Baixa" },
    { value: 1, label: "Moderada" },
    { value: 2, label: "Boa" },
    { value: 3, label: "Excelente" },
  ];
  const marksEnlace = [
    { value: 4, label: "Fina" },
    { value: 7, label: "Normal" },
    { value: 10, label: "Grossa" },
    { value: 13, label: "Muito Grossa" },
    { value: 16, label: "Extra Grossa" },
  ];

  useEffect(() => {
    if (!valorTempoGeo || !unidadeTempoGeo || valorTempoGeo < 1) return;
    setTempoColetaGeo(valorTempoGeo * unidadeTempoGeo);
  }, [valorTempoGeo, unidadeTempoGeo]);

  useEffect(() => {
    if (!valorTempoTop || !unidadeTempoTop || valorTempoTop < 1) return;
    setTempoColetaTop(valorTempoTop * unidadeTempoTop);
  }, [valorTempoTop, unidadeTempoTop]);

  useEffect(() => {
    if (!valorTempoFtth || !unidadeTempoFtth || valorTempoFtth < 1) return;
    setTempoColetaFtth(valorTempoFtth * unidadeTempoFtth);
  }, [valorTempoFtth, unidadeTempoFtth]);

  function formatMilliseconds(ms) {
    if (!ms || ms < 60000) {
      return { valor: 1, unidade: 60000 };
    } else if (ms < 60 * 60 * 1000) {
      const minutes = Math.floor(ms / 60000);
      return { valor: Math.max(1, minutes), unidade: 60000 };
    } else {
      const hours = Math.floor(ms / (60 * 60 * 1000));
      return { valor: Math.max(1, hours), unidade: 3600000 };
    }
  }

  const resolvePageIndex = (path) => {
    if (path.includes("geo") || path.includes("geolocalizado")) {
      setPageIndex({ title: "Backbone", id: "1.2.1" });
      setDefaultSelectedItems(["1", "1.2", "1.2.1"]);
    } else if (
      path.includes("top") ||
      path.includes("pop") ||
      path.includes("topologia")
    ) {
      setPageIndex({ title: "Infra", id: "2.1" });
      setDefaultSelectedItems(["2", "2.1"]);
    } else {
      setPageIndex({ title: "FTTH", id: "1.1.1" });
      setDefaultSelectedItems(["1", "1.1", "1.1.1"]);
    }
  };

  useEffect(() => {
    if (!config || !open.open) return;

    // setTabValue(tabDefault);
    const path = window.location.pathname;

    resolvePageIndex(path);

    // geolocalizado
    const geoconfig = config?.configuracoes?.geo;
    setLinkDark(
      geoconfig?.mapaTile?.dark ||
        "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    );
    setLinkLight(
      geoconfig?.mapaTile?.light ||
        "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    );
    if (geoconfig?.limiarRouter) setLimiar(parseFloat(config?.limiarRouter));
    if (geoconfig?.animacao?.linha != null)
      setAnimacaoLinhaGeo(geoconfig?.animacao?.linha);
    if (geoconfig?.animacao?.alertas != null)
      setAnimacaoAlertasGeo(geoconfig?.animacao?.alertas);

    setEscalaPotenciaGeo(ensureEscalaId(geoconfig?.camadaPotencia?.escala));
    setEscalaTrafegoGeo(ensureEscalaId(geoconfig?.camadaTrafego?.escala));
    const atualizacaoGeo = formatMilliseconds(geoconfig?.atualizacao || 60000);
    setValorTempoGeo(atualizacaoGeo.valor ? atualizacaoGeo.valor : 1);
    setUnidadeTempoGeo(atualizacaoGeo.unidade ? atualizacaoGeo.unidade : 60000);
    setEscalaPotenciaGeo(ensureEscalaId(geoconfig?.camadaPotencia?.escala));
    setEscalaTrafegoGeo(ensureEscalaId(geoconfig?.camadaTrafego?.escala));
    setFiltroPotenciaGeo(geoconfig?.camadaPotencia?.filtros || []);
    setFiltroTrafegoGeo(geoconfig?.camadaTrafego?.filtros || []);
    setSizeIconsGeo(geoconfig?.nodeSize || 5);
    if (geoconfig?.larguraEnlace) setLarguraEnlaceGeo(geoconfig?.larguraEnlace);

    // topologia
    const topconfig = config?.configuracoes?.top;
    if (topconfig?.animacao?.linha != null)
      setAnimacaoLinhaTop(topconfig?.animacao?.linha);
    if (topconfig?.animacao?.alertas != null)
      setAnimacaoAlertasTop(topconfig?.animacao?.alertas);
    setEscalaPotenciaTop(ensureEscalaId(topconfig?.camadaPotencia?.escala));
    setEscalaTrafegoTop(ensureEscalaId(topconfig?.camadaTrafego?.escala));
    const atualizacaoTop = formatMilliseconds(topconfig?.atualizacao || 60000);
    setValorTempoTop(atualizacaoTop.valor ? atualizacaoTop.valor : 1);
    setUnidadeTempoTop(atualizacaoTop.unidade ? atualizacaoTop.unidade : 60000);
    setEscalaPotenciaTop(ensureEscalaId(topconfig?.camadaPotencia?.escala));
    setEscalaTrafegoTop(ensureEscalaId(topconfig?.camadaTrafego?.escala));
    setFiltroPotenciaTop(topconfig?.camadaPotencia?.filtros || []);
    setFiltroTrafegoTop(topconfig?.camadaTrafego?.filtros || []);
    if (topconfig?.larguraEnlace) setLarguraEnlaceTop(topconfig?.larguraEnlace);

    // ftth
    const ftthconfig = config?.configuracoes?.ftth;
    setClusterFtth(ftthconfig?.clusterFtth ?? 16);
    setClusterArea(ftthconfig?.clusterArea ?? 5);
    setClusterIconSize(ftthconfig?.clusterIconSize ?? 5);
    setOnuIcon(ftthconfig?.onuIcon ?? 4);
    setNoDataElements(ftthconfig?.noDataElements ?? true);
    setFiltroPotencia(ftthconfig?.camadaFTTH?.filtros ?? []);
    const atualizacaoFtth = formatMilliseconds(
      ftthconfig?.atualizacao || 60000,
    );
    setValorTempoFtth(atualizacaoFtth.valor ? atualizacaoFtth.valor : 5);
    setUnidadeTempoFtth(
      atualizacaoFtth.unidade ? atualizacaoFtth.unidade : 300000,
    );
    setEscalaFtth(ensureEscalaId(ftthconfig?.camadaFTTH?.escala));
    if (ftthconfig?.animacao?.linha != null)
      setAnimacaoLinhaFtth(ftthconfig?.animacao?.linha);
    if (ftthconfig?.animacao?.alertas != null)
      setAnimacaoAlertasFtth(ftthconfig?.animacao?.alertas);

    if (ftthconfig?.linkFTTH) {
      const links = ftthconfig?.linkFTTH
        ?.split(",")
        ?.map((link) => link.trim());

      setLinkFtth((prev) => {
        const base = Array.isArray(prev) ? prev : [];
        const existing = new Set(base.map((i) => i.value));
        const additions = links
          .filter((link) => !existing.has(link))
          .map((link) => ({
            id: uuidv4(),
            value: link,
          }));

        return additions.length ? [...base, ...additions] : base;
      });
    }
  }, [config, open.open, open]);

  useEffect(() => {
    if (!Array.isArray(linkFtth) || linkFtth.length === 0) {
      setLinkFTTHVerification({});
      return;
    }

    const verificationLinks = linkFtth.reduce((acc, link) => {
      const url = String(link?.value ?? "").trim();

      acc[link.id] = !!url.match(/^(?!.*[,])(https?:\/\/)\S+$/);

      return acc;
    }, {});

    setLinkFTTHVerification(verificationLinks);
  }, [linkFtth]);

  function ensureEscalaId(escala) {
    return (escala || []).map((item) =>
      item.id ? item : { ...item, id: uuidv4() },
    );
  }

  const updatesTimes = () => {
    return (
      valorTempoFtth >= 1 &&
      valorTempoGeo >= 1 &&
      valorTempoTop >= 1 &&
      unidadeTempoFtth >= 60000 &&
      unidadeTempoGeo >= 60000 &&
      unidadeTempoTop >= 60000
    );
  };

  const hasTrafficErrors = useMemo(() => {
    return valorTempoGeo < 1 || unidadeTempoGeo < 1;
  }, [valorTempoGeo, unidadeTempoGeo]);

  const hasPowerErrors = useMemo(() => {
    return valorTempoTop < 1 || unidadeTempoTop < 1;
  }, [valorTempoTop, unidadeTempoTop]);

  const hasFtthErrors = useMemo(() => {
    const hasInvalidLink = Object.values(linkFTTHVerification).some(
      (isValid) => !isValid,
    );

    return valorTempoFtth < 1 || hasInvalidLink || unidadeTempoFtth < 1;
  }, [valorTempoFtth, unidadeTempoFtth, linkFTTHVerification]);

  const handleClose = () => {
    setLinkLight(null);
    setLinkDark(null);
    setMapCustom(null);
    setLimiar(null);
    setAnimacaoLinhaFtth(null);
    setAnimacaoAlertasFtth(null);
    setAnimacaoLinhaGeo(null);
    setAnimacaoAlertasGeo(null);
    setAnimacaoLinhaTop(null);
    setAnimacaoAlertasTop(null);

    setEscalaTrafegoGeo([]);
    setEscalaPotenciaGeo([]);
    setEscalaTrafegoTop([]);
    setEscalaPotenciaTop([]);

    setEscalaFtth([]);
    setLinkFtth([]);
    setCheckChanges(false);
    setValorTempoFtth(0);
    setUnidadeTempoFtth(0);

    setUnidadeTempoFtth(0);
    setValorTempoFtth(0);
    setUnidadeTempoGeo(0);
    setValorTempoGeo(0);
    setValorTempoTop(0);
    setUnidadeTempoTop(0);

    //setTabValue(0);
    setPageIndex({ title: "FTTH", id: "1.1.1" });
    setOpen({ open: false });
  };

  function valuetext(value) {
    return `${value}°C`;
  }

  async function handleApiUpdateConfig() {
    try {
      const response = await api.put("/settings/update", {
        product: "easymaps",
        productId: config.id,
        settings: {
          geo: {
            animacao: { linha: animacaoLinhaGeo, alertas: animacaoAlertasGeo },
            atualizacao: tempoColetaGeo,
            limiarRouter: parseFloat(limiar),
            mapaTile: { dark: linkDark, light: linkLight },
            nodeSize: sizeIconsGeo,
            larguraEnlace: larguraEnlaceGeo,
            camadaTrafego: {
              escala: escalaTrafegoGeo,
              filtros: filtroTrafegoGeo,
            },
            camadaPotencia: {
              escala: escalaPotenciaGeo,
              filtros: filtroPotenciaGeo,
            },
          },
          ftth: {
            noDataElements: noDataElements,
            clusterArea: clusterArea,
            clusterFtth: clusterFtth,
            clusterIconSize: clusterIconSize,
            atualizacao: tempoColetaFtth,
            linkFTTH: linkFtth
              ?.map((link) =>
                link.value?.endsWith("/")
                  ? link.value?.slice(0, -1)
                  : link.value,
              )
              .join(),
            mapaTile: { dark: linkDark, light: linkLight }, // caso queria o ftth com mapa diferente
            onuIcon: onuIcon,
            animacao: {
              linha: animacaoLinhaFtth,
              alertas: animacaoAlertasFtth,
            },
            camadaFTTH: {
              escala: escalaFtth,
              filtros: filtroPotencia,
            },
          },
          top: {
            animacao: { linha: animacaoLinhaTop, alertas: animacaoAlertasTop },
            atualizacao: tempoColetaTop,
            camadaTrafego: {
              escala: escalaTrafegoTop,
              filtros: filtroTrafegoTop,
            },
            camadaPotencia: {
              escala: escalaPotenciaTop,
              filtros: filtroPotenciaTop,
            },
            larguraEnlace: larguraEnlaceTop,
          },
        },
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children:
            "Error: Não foi possível salvar as mudanças as configurações",
          severity: "error",
        });
      } else {
        if (response.data) {
          setConfig(structuredClone(response.data));

          setConfigLocal(
            structuredClone({
              animacao: response?.data?.config?.animacao,
              noDataElements: response?.data?.config?.escalas?.noDataElements,
              filtroPotencia: response?.data?.config?.escalas?.filtroPotencia,
            }),
          );

          handleClose();
          setSnackbar({
            children: "Configurações salvas com sucesso!",
            severity: "success",
          });
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  const handleChange = (label, checked) => {
    setFiltroPotencia((prev) => {
      const arr = Array.isArray(prev) ? prev : [];
      return checked
        ? Array.from(new Set([...arr, label]))
        : arr.filter((l) => l !== label);
    });
    setCheckChanges(true);
  };

  const handleChangeField = (id, value) => {
    setCheckChanges(true);
    setLinkFtth((prev) => prev.map((f) => (f.id === id ? { ...f, value } : f)));
  };

  const handleRemoveField = (id) => {
    setCheckChanges(true);
    setLinkFtth((prev) => prev.filter((f) => f.id !== id));
  };

  const addField = () => {
    setLinkFtth((prev) => [...prev, { id: uuidv4(), value: "" }]);
  };
  const rightBarPages = useMemo(
    () => [
      {
        openItem: true,
        itemId: "1",
        label: "Mapa Geolocalizado",
        alert: hasTrafficErrors || hasFtthErrors,

        icon: <MapOutlined />,
        nodes: [
          {
            openItem: true,
            itemId: "1.1",
            label: "Tipo FTTH",
            nodes: [{ itemId: "1.1.1", label: "Gerais", alert: hasFtthErrors }],
            alert: hasFtthErrors,
          },
          {
            openItem: true,
            itemId: "1.2",
            label: "Tipo Backbone",
            alert: hasTrafficErrors,
            nodes: [
              { itemId: "1.2.1", label: "Gerais", alert: hasTrafficErrors },
              { itemId: "1.2.2", label: " Camada de Tráfego" },
              { itemId: "1.2.3", label: " Camada de Potência" },
            ],
          },
        ],
      },
      {
        openItem: true,
        itemId: "2",
        label: "Mapa de Topologia",
        icon: <RouteOutlined />,
        alert: hasPowerErrors,
        nodes: [
          { itemId: "2.1", label: "Gerais", alert: hasPowerErrors },
          { itemId: "2.2", label: " Camada de Tráfego" },
          { itemId: "2.3", label: " Camada de Potência" },
        ],
      },
    ],
    [hasTrafficErrors, hasPowerErrors, hasFtthErrors],
  );

  const handleDrawerToggle = () => {
    setOpenDrawer((prevState) => !prevState);
  };

  return (
    <>
      <Modal
        open={open.open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Card sx={isDownMd ? styles.containerMobile : styles.container}>
          <Stack
            sx={isDownMd ? styles.containerTabMobile : styles.containerTab}
          >
            {isDownMd ? (
              <>
                <IconButton sx={{ ml: 1 }} onClick={handleDrawerToggle}>
                  <MenuIcon />
                </IconButton>
                <Typography sx={styles.pageTitleMobile}>
                  Configurações Globais
                </Typography>
                <Drawer
                  variant="temporary"
                  open={openDrawer}
                  onClose={() => setOpenDrawer(false)}
                  sx={styles.drawerMobile}
                >
                  <CustomTreeView
                    key={"CustomTreeViewMobile"}
                    fullWidth={true}
                    open={true}
                    defaultSelectedItems={defaultSelectedItems}
                    setOpen={() => {}}
                    //closeOnClickItem
                    titlePage={"Configurações"}
                    onItemSelect={(item) => {
                      setOpenDrawer(false);
                      setPageIndex({ title: item.label, id: item.itemId });
                    }}
                    onItemsIdSelected={(items) => {
                      setDefaultSelectedItems(items);
                    }}
                    items={rightBarPages}
                  />{" "}
                </Drawer>
              </>
            ) : (
              <>
                <Typography sx={styles.pageTitleMobile}>
                  Configurações Globais
                </Typography>
                <CustomTreeView
                  fullWidth={true}
                  open={true}
                  defaultSelectedItems={defaultSelectedItems}
                  setOpen={() => {}}
                  //closeOnClickItem
                  titlePage={"Configurações"}
                  onItemSelect={(item) => {
                    setPageIndex({ title: item.label, id: item.itemId });
                  }}
                  items={rightBarPages}
                />
              </>
            )}
          </Stack>
          <Stack sx={styles.containerData}>
            <Typography sx={{ ...styles.pageTitle, ...styles.titlePage }}>
              {pageIndex.title || ""}
            </Typography>

            <Stack
              gap={1.5}
              sx={{ height: "100%", overflow: "auto", pr: "5px" }}
            >
              {/* mapa geolocalizado - ftth */}
              {pageIndex.id == "1.1.1" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Stack
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: 2,
                      }}
                    >
                      <Stack direction="column">
                        <Typography sx={styles.text}>Banco</Typography>

                        <Typography sx={{ ...styles.textFine }}>
                          Informe o link do banco de FTTH para gerar o mapa
                          automaticamente.
                        </Typography>
                      </Stack>
                      <Button
                        sx={{ textTransform: "none" }}
                        startIcon={<Add />}
                        onClick={() => addField()}
                        variant="text"
                      >
                        Adicionar
                      </Button>
                    </Stack>
                    <Stack gap={2} mt={2}>
                      {linkFtth?.map((field) => (
                        <Stack key={field.id} justifyContent="center">
                          <Stack
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: 0.5,
                            }}
                          >
                            <TextField
                              sx={styles.textField}
                              size="small"
                              value={field.value}
                              onChange={(e) =>
                                handleChangeField(field.id, e.target.value)
                              }
                              slotProps={{
                                input: {
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Typography sx={styles.textAdorment}>
                                        LINK
                                      </Typography>
                                    </InputAdornment>
                                  ),
                                },
                              }}
                            />

                            <IconButton
                              sx={{ color: theme.palette.text.primary }}
                              edge="end"
                              size="small"
                              onClick={() => handleRemoveField(field.id)}
                            >
                              <Delete />
                            </IconButton>
                          </Stack>
                          {field?.value && !linkFTTHVerification[field.id] && (
                            <Alerts
                              sx={{ mt: 1 }}
                              severity="warning"
                              title="Link inválido!"
                              message="Entre em contato com o suporte para obter ajuda!"
                            />
                          )}

                          {!field.value && (
                            <Alerts
                              sx={{ mt: 1 }}
                              severity="info"
                              title="Ainda não possui um banco configurado?"
                              message="Entre em contato com o suporte para obter ajuda!"
                            />
                          )}
                        </Stack>
                      ))}
                    </Stack>
                  </Box>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Escala de cluster
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Defina o nível de zoom em que os clusters de ONUs deixam
                        de ser exibidos e os pontos individuais passam a
                        aparecer no mapa.
                      </Typography>
                    </Stack>
                    <Stack sx={{ mt: 2 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography>Baixo</Typography>
                        <Typography>Alto</Typography>
                      </Box>
                      <Slider
                        size="small"
                        value={clusterFtth}
                        marks
                        min={2}
                        max={19}
                        step={1}
                        onChange={(e) => {
                          setCheckChanges(true);
                          setClusterFtth(e.target.value);
                        }}
                      />
                    </Stack>
                  </Box>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Customização de pontos e clusters
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          ...styles.textFine,
                          mb: 1,
                          color: "text.secondary",
                        }}
                      >
                        Personalize o tamanho da área de agrupamento dos
                        clusters e o tamanho dos ícones dos clusters e ONUs.
                      </Typography>
                    </Stack>
                    <Stack spacing={3} sx={{ width: "100%" }}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        sx={{ width: "100%" }}
                      >
                        <Typography variant="subtitle2" sx={{ minWidth: 160 }}>
                          Área do cluster
                        </Typography>
                        <Slider
                          value={
                            typeof clusterArea === "string"
                              ? Number(clusterArea)
                              : clusterArea
                          }
                          min={1}
                          max={10}
                          step={0.1}
                          onChange={(e, val) => {
                            setClusterArea(val);
                            setCheckChanges(true);
                          }}
                          valueLabelDisplay="auto"
                          sx={{ flex: 1, ml: 2 }}
                          size="small"
                        />
                      </Stack>
                      <Stack
                        direction="row"
                        alignItems="center"
                        sx={{ width: "100%" }}
                      >
                        <Typography variant="subtitle2" sx={{ minWidth: 160 }}>
                          Ícone do Cluster
                        </Typography>
                        <Slider
                          value={
                            typeof clusterIconSize === "string"
                              ? Number(clusterIconSize)
                              : clusterIconSize
                          }
                          min={1}
                          max={10}
                          step={0.1}
                          onChange={(e, val) => {
                            setClusterIconSize(val);
                            setCheckChanges(true);
                          }}
                          valueLabelDisplay="auto"
                          sx={{ flex: 1, ml: 2 }}
                          size="small"
                        />
                      </Stack>
                      <Stack
                        direction="row"
                        alignItems="center"
                        sx={{ width: "100%" }}
                      >
                        <Typography variant="subtitle2" sx={{ minWidth: 160 }}>
                          Ícone da ONU
                        </Typography>
                        <Slider
                          value={
                            typeof onuIcon === "string"
                              ? Number(onuIcon)
                              : onuIcon
                          }
                          min={1}
                          max={10}
                          step={0.1}
                          onChange={(e, val) => {
                            setOnuIcon(val);
                            setCheckChanges(true);
                          }}
                          valueLabelDisplay="auto"
                          sx={{ flex: 1, ml: 2 }}
                          size="small"
                        />
                      </Stack>
                      <Stack>
                        <Button
                          sx={styles.buttonEscalaConfig}
                          onClick={(e) => {
                            setCheckChanges(true);
                            setClusterArea(5);
                            setOnuIcon(4);
                            setClusterIconSize(5);
                          }}
                        >
                          Redefinir
                        </Button>
                      </Stack>
                    </Stack>
                  </Box>
                  {!ftthPing_flag && (
                    <Box sx={styles.boxOP}>
                      <Stack direction="column">
                        <Typography sx={styles.text}>Escalas</Typography>

                        <Typography sx={{ ...styles.textFine }}>
                          Defina as escalas para os mapas de FTTH clicando nas
                          cores. As escalas serão automaticamente ordenadas
                          conforme os valores definidos.
                        </Typography>
                      </Stack>

                      <Escala
                        variant="FTTH"
                        escala={JSON.parse(JSON.stringify(escalaFtth))}
                        setEscala={setEscalaFtth}
                        setCheckChanges={setCheckChanges}
                      />
                    </Box>
                  )}
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Tempo de atualização
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Defina o intervalo de tempo para coleta dos dados do
                        mapa FTTH.
                      </Typography>
                    </Stack>
                    <Stack gap={2} mt={2} direction={"row"}>
                      <Stack
                        justifyContent={"center"}
                        direction={"row"}
                        gap={1}
                      >
                        <TextField
                          onChange={(e) => {
                            setCheckChanges(true);
                            setValorTempoFtth(
                              e.target.value >= 0 && e.target.value < 60
                                ? e.target.value
                                : e.target.value < 0
                                  ? 1
                                  : 59,
                            );
                          }}
                          error={valorTempoFtth < 1}
                          value={valorTempoFtth != null ? valorTempoFtth : 5}
                          sx={[styles.textField, { width: "100px" }]}
                          size="small"
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Typography sx={styles.textAdorment}>
                                    TEMPO
                                  </Typography>
                                </InputAdornment>
                              ),
                            },
                          }}
                        />

                        <TextField
                          select
                          onChange={(e) => {
                            setCheckChanges(true);
                            setUnidadeTempoFtth(e.target.value);
                          }}
                          value={unidadeTempoFtth ? unidadeTempoFtth : 60000}
                          sx={[styles.textField, { width: "fit-content" }]}
                          size="small"
                        >
                          {/* <MenuItem value={1000}>segundo(s)</MenuItem> */}
                          <MenuItem value={60000}>minuto(s)</MenuItem>
                          <MenuItem value={3600000}>hora(s)</MenuItem>
                        </TextField>
                      </Stack>
                    </Stack>
                    {valorTempoFtth < 1 && (
                      <Alerts
                        sx={{ mt: 1 }}
                        severity="error"
                        message="Tempo de coleta invalido!"
                      ></Alerts>
                    )}
                  </Box>
                  {!ftthPing_flag && (
                    <FiltroEscala
                      unit="dBm"
                      type="FTTH"
                      escala={escalaFtth}
                      filtroData={filtroPotencia}
                      setCheckChanges={setCheckChanges}
                      setFiltroData={setFiltroPotencia}
                      theme={theme}
                      styles={styles}
                    />
                  )}
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>Animações</Typography>

                      <Typography sx={styles.textFine}>
                        Habilite ou desabilite as animações nas linhas ou nos
                        ícones em todos os mapas
                      </Typography>
                    </Stack>

                    <Stack
                      justifyContent={"center"}
                      alignItems={"start"}
                      mt={2}
                      gap={1}
                    >
                      <FormControlLabel
                        control={
                          <Switch
                            size="small"
                            checked={animacaoAlertasFtth}
                            onChange={(e) => {
                              setCheckChanges(true);
                              setAnimacaoAlertasFtth(e.target.checked);
                            }}
                          />
                        }
                        sx={styles.switch}
                        labelPlacement="start"
                        label={
                          <Typography sx={[styles.textAdorment, { ml: 0.3 }]}>
                            ANIMAÇÃO DE ALERTAS
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            size="small"
                            checked={animacaoLinhaFtth}
                            onChange={(e) => {
                              setCheckChanges(true);
                              setAnimacaoLinhaFtth(e.target.checked);
                            }}
                          />
                        }
                        sx={styles.switch}
                        labelPlacement="start"
                        label={
                          <Typography sx={[styles.textAdorment, { ml: 0.3 }]}>
                            ANIMAÇÃO DE LINHAS
                          </Typography>
                        }
                      />
                    </Stack>
                  </Box>
                </>
              )}
              {/* mapa geolocalizado  */}
              {pageIndex.id == "1.2.1" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}> Links dos tiles</Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Links dos servidores que fornecem mapas de fundo para os
                        mapas com geolocalização.
                      </Typography>
                    </Stack>
                    <Stack gap={2} mt={2}>
                      <>
                        <Stack justifyContent={"center"}>
                          <TextField
                            sx={styles.textField}
                            value={linkLight}
                            onChange={(e) => {
                              setCheckChanges(true);
                              setLinkLight(e.target.value);
                            }}
                            size="small"
                            slotProps={{
                              input: {
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Typography sx={styles.textAdorment}>
                                      MODO CLARO
                                    </Typography>
                                  </InputAdornment>
                                ),
                              },
                            }}
                          />
                        </Stack>
                        <Stack justifyContent={"center"}>
                          <TextField
                            sx={styles.textField}
                            size="small"
                            value={linkDark}
                            onChange={(e) => {
                              setCheckChanges(true);
                              setLinkDark(e.target.value);
                            }}
                            slotProps={{
                              input: {
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Typography sx={styles.textAdorment}>
                                      MODO ESCURO
                                    </Typography>
                                  </InputAdornment>
                                ),
                              },
                            }}
                          />
                        </Stack>
                      </>
                    </Stack>
                  </Box>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Espessura do Enlace
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Selecione o nível de espessura das linhas que
                        representam os enlaces no mapa. Opções mais altas tornam
                        as linhas mais grossas, facilitando a visualização em
                        mapas com muitos enlaces. No entanto, espessuras maiores
                        podem deixar o mapa visualmente mais carregado.
                      </Typography>
                    </Stack>

                    <Stack
                      justifyContent={"center"}
                      mt={2}
                      sx={{ width: "98%", p: "0px 19px" }}
                    >
                      <Slider
                        aria-label="Restricted values"
                        value={larguraEnlaceGeo}
                        onChange={(e) => {
                          setCheckChanges(true);
                          setLarguraEnlaceGeo(e.target.value);
                        }}
                        min={4}
                        max={16}
                        step={null}
                        marks={marksEnlace}
                        valueLabelDisplay="off"
                        getAriaValueText={valuetext}
                        size="small"
                      />
                    </Stack>
                  </Box>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Precisão do roteamento automático
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        A precisão define a quantidade de pontos gerados durante
                        o roteamento automático. Quanto maior for a precisão,
                        mais pontos serão gerados e mais processamento será
                        necessário.
                      </Typography>
                    </Stack>

                    <Stack
                      justifyContent={"center"}
                      mt={2}
                      sx={{ width: "98%", p: "0px 19px" }}
                    >
                      <Slider
                        aria-label="Restricted values"
                        value={limiar}
                        onChange={(e) => {
                          setCheckChanges(true);
                          setLimiar(e.target.value);
                        }}
                        min={0}
                        max={3}
                        step={null}
                        marks={marks}
                        valueLabelDisplay="off"
                        getAriaValueText={valuetext}
                        size="small"
                      />
                    </Stack>
                    {limiar == 3 && (
                      <Stack sx={{ mt: 1 }}>
                        <Alerts
                          title={"Alerta de Desempenho "}
                          message="Esta configuração irá usar mais recursos do sistema, o que pode afetar o desempenho dependendo da configuração do seu hardware."
                          severity="warning"
                        />
                      </Stack>
                    )}
                  </Box>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Tamanho dos ícones de hosts
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          ...styles.textFine,
                          mb: 1,
                          color: "text.secondary",
                        }}
                      >
                        Personalize tamanho dos ícones de hosts, selecionando
                        uma opção.
                      </Typography>
                    </Stack>
                    <Stack spacing={3} sx={{ width: "100%" }}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        sx={{ width: "100%" }}
                      >
                        <Slider
                          value={Number(sizeIconsGeo)}
                          min={1}
                          max={10}
                          step={0.1}
                          onChange={(e, val) => {
                            setSizeIconsGeo(val);
                            setCheckChanges(true);
                          }}
                          valueLabelDisplay="auto"
                          sx={{ flex: 1 }}
                          size="small"
                        />
                      </Stack>

                      <Stack>
                        <Button
                          sx={styles.buttonEscalaConfig}
                          onClick={(e) => {
                            setCheckChanges(true);
                            setSizeIconsGeo(3);
                          }}
                        >
                          Redefinir
                        </Button>
                      </Stack>
                    </Stack>
                  </Box>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>Animações</Typography>

                      <Typography sx={styles.textFine}>
                        Habilite ou desabilite as animações nas linhas ou nos
                        ícones em todos os mapas
                      </Typography>
                    </Stack>

                    <Stack
                      justifyContent={"center"}
                      alignItems={"start"}
                      mt={2}
                      gap={1}
                    >
                      <FormControlLabel
                        control={
                          <Switch
                            size="small"
                            checked={animacaoAlertasGeo}
                            onChange={(e) => {
                              setCheckChanges(true);
                              setAnimacaoAlertasGeo(e.target.checked);
                            }}
                          />
                        }
                        sx={styles.switch}
                        labelPlacement="start"
                        label={
                          <Typography sx={[styles.textAdorment, { ml: 0.3 }]}>
                            ANIMAÇÃO DE ALERTAS
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            size="small"
                            checked={animacaoLinhaGeo}
                            onChange={(e) => {
                              setCheckChanges(true);
                              setAnimacaoLinhaGeo(e.target.checked);
                            }}
                          />
                        }
                        sx={styles.switch}
                        labelPlacement="start"
                        label={
                          <Typography sx={[styles.textAdorment, { ml: 0.3 }]}>
                            ANIMAÇÃO DE LINHAS
                          </Typography>
                        }
                      />
                    </Stack>
                  </Box>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Tempo de atualização
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Defina o tempo de atualização dos dados de tráfego.
                      </Typography>
                    </Stack>
                    <Stack gap={2} mt={2} direction={"row"}>
                      <Stack
                        justifyContent={"center"}
                        direction={"row"}
                        gap={1}
                      >
                        <TextField
                          onChange={(e) => {
                            setCheckChanges(true);

                            setValorTempoGeo(
                              e.target.value >= 0 && e.target.value < 60
                                ? e.target.value
                                : e.target.value < 0
                                  ? 1
                                  : 59,
                            );
                          }}
                          error={valorTempoGeo < 1}
                          type="number"
                          value={valorTempoGeo != null ? valorTempoGeo : 1}
                          sx={[styles.textField, { width: "100px" }]}
                          size="small"
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Typography sx={styles.textAdorment}>
                                    TEMPO
                                  </Typography>
                                </InputAdornment>
                              ),
                            },
                          }}
                        />

                        <TextField
                          select
                          onChange={(e) => {
                            setCheckChanges(true);
                            setUnidadeTempoGeo(e.target.value);
                          }}
                          value={unidadeTempoGeo ? unidadeTempoGeo : 60000}
                          sx={[styles.textField, { width: "fit-content" }]}
                          size="small"
                        >
                          <MenuItem value={60000}>minuto(s)</MenuItem>
                          <MenuItem value={3600000}>hora(s)</MenuItem>
                        </TextField>
                      </Stack>
                    </Stack>{" "}
                    {valorTempoGeo < 1 && (
                      <Alerts
                        sx={{ mt: 1 }}
                        severity="error"
                        message="Tempo de coleta invalido!"
                      ></Alerts>
                    )}
                  </Box>
                </>
              )}
              {pageIndex.id == "1.2.2" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>Escalas</Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Defina as escalas para as camadas de tráfego clicando
                        nas cores. Elas serão ordenadas automaticamente com base
                        nos valores.
                      </Typography>
                    </Stack>

                    <Escala
                      variant="traffic"
                      escala={structuredClone(escalaTrafegoGeo)}
                      setEscala={setEscalaTrafegoGeo}
                      setCheckChanges={setCheckChanges}
                    />
                  </Box>
                  <FiltroEscala
                    inverted={true}
                    unit="%"
                    type="Tráfego"
                    escala={escalaTrafegoGeo}
                    filtroData={filtroTrafegoGeo}
                    setCheckChanges={setCheckChanges}
                    setFiltroData={setFiltroTrafegoGeo}
                    theme={theme}
                    styles={styles}
                  />
                </>
              )}
              {pageIndex.id == "1.2.3" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>Escalas</Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Defina as escalas para as camadas de Potência clicando
                        nas cores. Elas serão ordenadas automaticamente com base
                        nos valores.
                      </Typography>
                    </Stack>
                    <Escala
                      variant="power"
                      escala={structuredClone(escalaPotenciaGeo)}
                      setEscala={setEscalaPotenciaGeo}
                      setCheckChanges={setCheckChanges}
                      disableNew={true}
                    />
                  </Box>
                  <FiltroEscala
                    inverted={true}
                    unit=""
                    type="Potência"
                    escala={escalaPotenciaGeo}
                    filtroData={filtroPotenciaGeo}
                    setCheckChanges={setCheckChanges}
                    setFiltroData={setFiltroPotenciaGeo}
                    theme={theme}
                    styles={styles}
                  />
                </>
              )}
              {/* mapa topologia */}

              {pageIndex.id == "2.1" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Espessura do Enlace
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Selecione o nível de espessura das linhas que
                        representam os enlaces no mapa. Opções mais altas tornam
                        as linhas mais grossas, facilitando a visualização em
                        mapas com muitos enlaces. No entanto, espessuras maiores
                        podem deixar o mapa visualmente mais carregado.
                      </Typography>
                    </Stack>

                    <Stack
                      justifyContent={"center"}
                      mt={2}
                      sx={{ width: "98%", p: "0px 19px" }}
                    >
                      <Slider
                        aria-label="Restricted values"
                        value={larguraEnlaceTop}
                        onChange={(e) => {
                          setCheckChanges(true);
                          setLarguraEnlaceTop(e.target.value);
                        }}
                        min={4}
                        max={16}
                        step={null}
                        marks={marksEnlace}
                        valueLabelDisplay="off"
                        getAriaValueText={valuetext}
                        size="small"
                      />
                    </Stack>
                  </Box>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>Animações</Typography>

                      <Typography sx={styles.textFine}>
                        Habilite ou desabilite as animações nas linhas ou nos
                        ícones em todos os mapas
                      </Typography>
                    </Stack>

                    <Stack
                      justifyContent={"center"}
                      alignItems={"start"}
                      mt={2}
                      gap={1}
                    >
                      <FormControlLabel
                        control={
                          <Switch
                            size="small"
                            checked={animacaoAlertasTop}
                            onChange={(e) => {
                              setCheckChanges(true);
                              setAnimacaoAlertasTop(e.target.checked);
                            }}
                          />
                        }
                        sx={styles.switch}
                        labelPlacement="start"
                        label={
                          <Typography sx={[styles.textAdorment, { ml: 0.3 }]}>
                            ANIMAÇÃO DE ALERTAS
                          </Typography>
                        }
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            size="small"
                            checked={animacaoLinhaTop}
                            onChange={(e) => {
                              setCheckChanges(true);
                              setAnimacaoLinhaTop(e.target.checked);
                            }}
                          />
                        }
                        sx={styles.switch}
                        labelPlacement="start"
                        label={
                          <Typography sx={[styles.textAdorment, { ml: 0.3 }]}>
                            ANIMAÇÃO DE LINHAS
                          </Typography>
                        }
                      />
                    </Stack>
                  </Box>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        Tempo de atualização
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Defina o tempo de atualização dos dados de tráfego.
                      </Typography>
                    </Stack>
                    <Stack gap={2} mt={2} direction={"row"}>
                      <Stack
                        justifyContent={"center"}
                        direction={"row"}
                        gap={1}
                      >
                        <TextField
                          onChange={(e) => {
                            setCheckChanges(true);

                            setValorTempoTop(
                              e.target.value >= 0 && e.target.value < 60
                                ? e.target.value
                                : e.target.value < 0
                                  ? 1
                                  : 59,
                            );
                          }}
                          error={valorTempoTop < 1}
                          type="number"
                          value={valorTempoTop != null ? valorTempoTop : 1}
                          sx={[styles.textField, { width: "100px" }]}
                          size="small"
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Typography sx={styles.textAdorment}>
                                    TEMPO
                                  </Typography>
                                </InputAdornment>
                              ),
                            },
                          }}
                        />

                        <TextField
                          select
                          onChange={(e) => {
                            setCheckChanges(true);
                            setUnidadeTempoTop(e.target.value);
                          }}
                          value={unidadeTempoTop < 1 ? unidadeTempoTop : 60000}
                          sx={[styles.textField, { width: "fit-content" }]}
                          size="small"
                        >
                          <MenuItem value={60000}>minuto(s)</MenuItem>
                          <MenuItem value={3600000}>hora(s)</MenuItem>
                        </TextField>
                      </Stack>
                    </Stack>{" "}
                    {valorTempoTop < 1 && (
                      <Alerts
                        sx={{ mt: 1 }}
                        severity="error"
                        message="Tempo de coleta invalido!"
                      ></Alerts>
                    )}
                  </Box>
                </>
              )}
              {pageIndex.id == "2.2" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>Escalas</Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Defina as escalas para as camadas de tráfego clicando
                        nas cores. Elas serão ordenadas automaticamente com base
                        nos valores.
                      </Typography>
                    </Stack>

                    <Escala
                      variant="traffic"
                      escala={structuredClone(escalaTrafegoTop)}
                      setEscala={setEscalaTrafegoTop}
                      setCheckChanges={setCheckChanges}
                    />
                  </Box>
                  <Box sx={styles.boxOP}>
                    <FiltroEscala
                      inverted={true}
                      unit="%"
                      type="Tráfego"
                      escala={escalaTrafegoTop}
                      filtroData={filtroTrafegoTop}
                      setCheckChanges={setCheckChanges}
                      setFiltroData={setFiltroTrafegoTop}
                      theme={theme}
                      styles={styles}
                    />
                  </Box>
                </>
              )}
              {pageIndex.id == "2.3" && (
                <>
                  <Box sx={styles.boxOP}>
                    <Stack direction="column">
                      <Typography sx={styles.text}>Escalas</Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Defina as escalas para as camadas de Potência clicando
                        nas cores. Elas serão ordenadas automaticamente com base
                        nos valores.
                      </Typography>
                    </Stack>
                    <Escala
                      variant="power"
                      escala={structuredClone(escalaPotenciaTop)}
                      setEscala={setEscalaPotenciaTop}
                      setCheckChanges={setCheckChanges}
                      disableNew={true}
                    />
                  </Box>
                  <Box sx={styles.boxOP}>
                    <FiltroEscala
                      inverted={true}
                      unit=""
                      type="Potência"
                      escala={escalaPotenciaTop}
                      filtroData={filtroPotenciaTop}
                      setCheckChanges={setCheckChanges}
                      setFiltroData={setFiltroPotenciaTop}
                      theme={theme}
                      styles={styles}
                    />
                  </Box>
                </>
              )}
            </Stack>
            <Stack
              direction={"row"}
              gap={1}
              justifyContent={"flex-end"}
              sx={{ height: "50px", mt: 2, mb: 1 }}
            >
              <Button
                onClick={() => {
                  if (!checkChanges) {
                    handleClose();
                    return;
                  }
                  setOpenAlertModal({
                    open: true,
                    callback: handleClose,
                    severity: "error",
                    severity: "warning",
                    text: "As alterações feitas não foram salvas. Se prosseguir com a operação as mudanças serão perdidas.",
                  });
                }}
                sx={styles.buttomEnd}
                startIcon={<CloseOutlined />}
                variant="text"
                color="primary"
              >
                Cancelar
              </Button>
              <Button
                onClick={handleApiUpdateConfig}
                sx={styles.buttomEnd}
                variant="contained"
                color="primary"
                startIcon={<Check />}
                disabled={
                  !checkChanges ||
                  Object.values(linkFTTHVerification).some(
                    (isValid) => !isValid,
                  ) ||
                  !updatesTimes()
                }
                size="small"
              >
                Salvar
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Modal>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
      <AlertModal
        openModal={openAlertModal?.open ?? false}
        setOpenModal={(data) => setOpenAlertModal({ open: data })}
        buttonText={openAlertModal?.buttonText}
        buttonCancelText={openAlertModal?.buttonCancelText}
        confirmar={false}
        handleButton={() => {
          setOpenAlertModal({ open: false });
          if (openAlertModal.callback) {
            openAlertModal.callback(...(openAlertModal?.params || []));
            return;
          }
        }}
        severity={openAlertModal?.severity}
        singleButton={false}
        textContent={openAlertModal?.text}
      />
    </>
  );
}
